// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

export const getFundraiseForm = state => state.fundraiseReducer.fundraiseForm;
export const getError = state => state.fundraiseReducer.error;
export const getIsButtonPressed = state => state.fundraiseReducer.isButtonPressed;
export const getData = state => state.fundraiseReducer.data;
export const getStatus = state => state.fundraiseReducer.status;
